const Galeria = ({ images }) => {

    return (
        <ul className="galeria nav">
            { images.map( (image, index) => (
                <li key={index} className="nav-item border">
                    <img src={image} alt="galety image" />
                </li>

            ))}
        </ul>
    )

}

export default Galeria;
